<template>
  <b-container class="bv-example-row bv-example-row-flex-cols" fluid>
    <b-row align-v="center">
      <b-col cols="auto">
        <multiselect
          v-model="hospitalSelectedComputed"
          style="min-width: 250px;"
          :tabindex="-1"
          :options="hospitalsInput"
          label="name"
          track-by="id"
          select-label=""
          deselect-label="✖"
          selected-label=""
          placeholder="-- เลือกสถานพยาบาล --"
        />
        <!--        <b-form-select-->
        <!--          v-model="hospitalSelectedComputed"-->
        <!--          value-field="id"-->
        <!--          text-field="name"-->
        <!--          :options="hospitals"-->
        <!--          size="sm"-->
        <!--        >-->
        <!--          <template slot="first">-->
        <!--            <option-->
        <!--              :value="null"-->
        <!--              disabled-->
        <!--            >-->
        <!--              &#45;&#45; เลือกสถานพยาบาล &#45;&#45;-->
        <!--            </option>-->
        <!--            <option value="all">-->
        <!--              เลือกทั้งหมด-->
        <!--            </option>-->
        <!--          </template>-->
        <!--        </b-form-select>-->
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="directionFilterSelectedComputed"
          value-field="id"
          text-field="direction"
          :options="directions"
          size="sm"
        >
          <template slot="first">
            <option :value="null">
              เส้นทางทั้งหมด
            </option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="statusFilterSelectedComputed"
          value-field="id"
          text-field="name"
          :options="paymentStatus"
          size="sm"
        >
          <template slot="first">
            <option :value="null" disabled>
              -- เลือกสถานะ --
            </option>
            <option value="all">
              สถานะทั้งหมด
            </option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="creditTypeSelectedComputed"
          value-field="id"
          text-field="type_name"
          :options="creditType"
          size="sm"
        >
          <template slot="first">
            <option :value="null" disabled>
              -- เลือกเครดิต --
            </option>
            <option value="all">
              ทั้งหมด
            </option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TestFilterComponent",
  props: {
    hospitalSelected: {
      required: true,
    },
    statusFilter: {
      required: true,
    },
    directionFilterSelected: {
      required: true,
    },
    creditTypeSelected: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      hospitals: "Hospital/getAll",
      paymentStatus: "Account/getPaymentStatuses",
      directions: "Direction/getAll",
      creditType: "CreditType/getAll",
    }),
    hospitalsInput() {
      let hospitals = this.$rfdc(this.hospitals);
      hospitals.unshift({ id: "all", name: "เลือกทั้งหมด" });
      return hospitals;
    },
    hospitalSelectedComputed: {
      get() {
        return this.hospitals.find(
          (hospital) => hospital.id === this.hospitalSelected
        );
        // return this.hospitalSelected
      },
      set(value) {
        this.$emit("update:hospitalSelected", value.id);
      },
    },
    statusFilterSelectedComputed: {
      get() {
        return this.statusFilter;
      },
      set(value) {
        this.$emit("update:statusFilter", value);
      },
    },
    directionFilterSelectedComputed: {
      get() {
        return this.directionFilterSelected;
      },
      set(val) {
        this.$emit("update:directionFilterSelected", val);
      },
    },
    creditTypeSelectedComputed: {
      get() {
        return this.creditTypeSelected;
      },
      set(val) {
        this.$emit("update:creditTypeSelected", val);
      },
    },
  },
};
</script>

<style scoped></style>
